<template>
  <div class="content">
    <span class="content_title">
      <h2>{{ Titles }}《典当到期、续当提醒》</h2>
    </span>

    <div class="content_contens">
      <h3>尊敬的当户: {{ TextData.name }}</h3>
    </div>

    <div class="content_contens">
      您当票号:{{ TextData.ticketnumber }}（当金{{ TextData.price }}元）在{{
        year
      }}到期，提醒您在期限内续费，逾期续/赎当须按月费率4.2%计费且上期典当利息不减免。
    </div>

    <div class="content_contens">
      <h3>按时在期限内续当15天：</h3>
      续期15天按1.89%计收综合费{{
        Math.trunc(TextData.price * 0.0189)
      }}元和该15天内的典当利息0.14%可以减免。 （续费后当期从{{ newDate }}续到{{ endDate }}止）。
    </div>

    <div class="content_contens">
      <h3>按时在期限内续当30天：</h3>
      续期30天按2.5%计收综合费{{
        Math.trunc(TextData.price * 0.025)
      }}元，典当利息后收（在到期日）按0.29%收取。 （续费后当期从{{ newDate }}续到{{ thirtyEndDate }}日止）。
    </div>

    <div class="content_contens">
      <h3>按时在期限内续当60天：</h3>
      续期60天按4%计收综合费{{ Math.trunc(TextData.price * 0.04) }}元和该60天内的典当利息0.58%可以减免。
      （续费后当期从{{ newDate }}续到{{ sixty }}日止）。
    </div>

    <div class="content_contens">
      <h3>逾期5天内续当：</h3>
      续期30天按4.2%计收综合费{{ Math.trunc(TextData.price * 0.042) }}元和收取上期（{{
        lastDate.dday == undefined ? TextData.days + "天" : lastDate.dday + "天"
      }}）典当利息{{
        lastDate.dday !== undefined
          ? Math.trunc(TextData.price * 0.0029)
          : Math.trunc(TextData.price * 0.0029)
      }}元，合计：{{
        lastDate.dday !== undefined
          ? Math.trunc(TextData.price * 0.042) + Math.trunc(TextData.price * 0.0029)
          : Math.trunc(TextData.price * 0.042) + Math.trunc(TextData.price * 0.0029)
      }}元。 （续费后当期从{{ newDate }}续到{{ thirtyDate }}止）。
    </div>

    <div class="content_contens">
      <h3>逾期赎当：</h3>
      逾期5天内赎当具体按当票约定结清综合费、典当利息和当金。
    </div>

    <div class="content_contens">
      <h3>绝当:</h3>
      您当票号：{{TextData.ticketnumber}}（当金{{TextData.price}}）在{{year}}到期,逾期满5天既不赎当也不续当的，从{{jdate}}，起视为绝当（不得赎回当物，典当行可以自行变卖绝当物，损益自负）。
    </div>

    <div class="content_title">
      <h3>
        上述仅为续当提醒，您的续当事宜最终以《续当凭证》为准。请您留心典当期限，避免因逾期失去适用会员优惠费率！!
      </h3>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
export default {
  name: "DialogTextDetail",

  props: ["TextData", "Titles", "lastDate"],

  data() {
    return {
      year: "",

      newDate: "",

      endDate: "", //15天结束日期
      thirtyEndDate: "", //30天结束日期
      twentyFive: "", //25天结束日期
      sixty: "", //60天结束日期
      thirtyDate: "",
      jdate:"", //绝当日期
    };
  },

  mounted() {
    this.year = dayjs(this.TextData.enddate).format("YYYY年MM月DD日");

    this.newDate = dayjs(this.TextData.enddate).add(1, "day").format("YYYY年MM月DD日");

    this.endDate = dayjs(this.TextData.enddate).add(15, "day").format("YYYY年MM月DD日"); //15天结束日期

    this.jdate = dayjs(this.TextData.enddate).add(6, "day").format("YYYY年MM月DD日")  //绝当日期

    this.thirtyEndDate = dayjs(this.TextData.enddate)
      .add(30, "day")
      .format("YYYY年MM月DD日"); //30天结束日期
    this.sixty = dayjs(this.TextData.enddate).add(60, "day").format("YYYY年MM月DD日");
    // (
    //   (this.twentyFive = dayjs(this.TextData.enddate)
    //     .add(25, "day")
    //     .format("YYYY年MM月DD日"))
    // )), //25天结束日期
    //   (this.this.thirtyDate = dayjs(this.TextData.enddate)
    //     .add(30, "day")
    //     .format("YYYY年MM月DD日"));

    // setTimeout(() => {
    //   console.log(this.lastDate);
    //   // console.log(this.newUpdate(15));
    //   console.log(dayjs(this.TextData.enddate).add(15, "day").format("YYYY年MM月DD日"));
    // }, 1000);
  },
  updated() {
    this.year = dayjs(this.TextData.enddate).format("YYYY年MM月DD日");

    this.newDate = dayjs(this.TextData.enddate).add(1, "day").format("YYYY年MM月DD日");

    this.endDate = dayjs(this.TextData.enddate).add(15, "day").format("YYYY年MM月DD日");

    this.thirtyDate = dayjs(this.TextData.enddate)
      .add(30, "day")
      .format("YYYY年MM月DD日");
  },

  newUpdate(dates) {
    console.log(dates);
    let dat = Number(dates);
    let newDates = dayjs(this.TextData.enddate).add(dat, "day").format("YYYY年MM月DD日");
    return newDates;
  },
};
</script>
<style scoped>
.content_title {
  text-align: center;
  font-size: 18px;
}
.content_contens {
  margin: 10px 30px;
  font-size: 18px;
}
</style>
